import React from "react"
import styled, { css } from "styled-components"
import OrangeFilledCheck from "@images/knowledge-center/orange-filled-check.svg"
import GreenFilledCheck from "@images/knowledge-center/green-filled-check.svg"
import BlueFilledCheck from "@images/knowledge-center/blue-filled-check.svg"
import OrangeCheck from "@images/knowledge-center/orange-check.svg"
import GreenCheck from "@images/knowledge-center/green-check.svg"
import BlueCheck from "@images/knowledge-center/blue-check.svg"
import { EncircledIcon, GenericIcon } from "@abmg-components"

// Utils
import {
  CategoryColorLightFinder,
  CategoryColorDarkFinder,
} from "@utils/knowledge-center"

const size = {
  tablet: 950,
  mobile: 600,
}

const above = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const Wrapper = styled.div`
  border: 1px solid #e5eaf1;
  margin: 0 24px 48px;
  padding: 24px;
  ${above.mobile`
  margin: 0 48px 64px;
  `}
  ${above.tablet`
      max-width: 724px;
    margin: 0 auto 80px;
  `}
`

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  img,
  svg {
    flex-shrink: 0;
    margin-right: 16px;
  }
  h3 {
    font-family: "Source Sans Pro";
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: var(--alt-black);
    ${above.mobile`
    font-size:20px;
    line-height:28px;
    margin-bottom:12px;
    `}
  }

  ${above.mobile`
  flex-direction:column;
  align-items:flex-start;
  margin-bottom:0;
  `}
`

const CheckItemContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  ${above.mobile`
    margin-bottom:12px;
    `}
  &:last-of-type {
    margin-bottom: 0;
  }
  img,
  svg {
    flex-shrink: 0;
    margin-right: 16px;
  }
  p {
    font-size: 16px;
    line-height: 20px;
    color: var(--alt-black);
    margin-bottom: 0;
    ${above.mobile`
    font-size:20px;
    line-height:24px;
    `}
  }
`
const WYLMobile = styled.div`
  ${above.mobile`
display:none;
`}
`

const WYLTabletDesktop = styled.div`
  display: flex;
  align-items: flex-start;
  img,
  svg {
    flex-shrink: 0;
    margin-right: 24px;
  }
  @media (max-width: 599px) {
    display: none;
  }
`

const WhatYouLearn = ({ articleData }) => {
  const filledCheck = () => {
    if (articleData.category === "finances") {
      return GreenFilledCheck
    }
    if (articleData.category === "mortgages") {
      return BlueFilledCheck
    }
    if (articleData.category === "homeownership") {
      return OrangeFilledCheck
    }
  }

  const Check = () => {
    if (articleData.category === "finances") {
      return GreenCheck
    }
    if (articleData.category === "mortgages") {
      return BlueCheck
    }
    if (articleData.category === "homeownership") {
      return OrangeCheck
    }
  }

  return (
    <Wrapper>
      <WYLMobile>
        <TitleContainer>
          {/* <img src={filledCheck()} alt="filled check icon" /> */}
          <EncircledIcon
            icon="check"
            circleColor={CategoryColorLightFinder(articleData.category)}
            height={48}
            width={48}
          />
          <h3>WHAT YOU'LL LEARN</h3>
        </TitleContainer>

        {articleData.whatYouLearn.map((item, index) => (
          <CheckItemContainer key={index}>
            {/* <img src={Check()} alt="check icon" /> */}
            <GenericIcon
              icon="check"
              color={CategoryColorDarkFinder(articleData.category)}
            />
            <p>{item.textBody}</p>
          </CheckItemContainer>
        ))}
      </WYLMobile>
      <WYLTabletDesktop>
        {/* <img src={filledCheck()} alt="filled check icon" /> */}
        <EncircledIcon
          icon="check"
          circleColor={CategoryColorLightFinder(articleData.category)}
          height={48}
          width={48}
        />
        <TitleContainer>
          <h3>WHAT YOU'LL LEARN</h3>
          {articleData.whatYouLearn.map((item, index) => (
            <CheckItemContainer key={index}>
              {/* <img src={Check()} alt="check icon" /> */}
              <GenericIcon
                icon="check"
                color={CategoryColorDarkFinder(articleData.category)}
              />
              <p>{item.textBody}</p>
            </CheckItemContainer>
          ))}
        </TitleContainer>
      </WYLTabletDesktop>
    </Wrapper>
  )
}

export default WhatYouLearn
